<template>
  <div class="pa-4">
    <v-chip label outlined>
      {{ games.length }}
    </v-chip>
    <div>
      <v-progress-circular indeterminate v-if="loading_games"></v-progress-circular>
    </div>
    <div v-for="game in games" :key="game.id" class="mt-4">
      <ImportLeagueGamesGame
        :oldGame="game"
        @saved="gameSaved($event)"
        @events_saved="eventsSaved($event)"
        @game_deleted="gameDeleted($event)"
      />
    </div>
  </div>
</template>

<script>
import a from '@/utils/axios/axios'
import ImportLeagueGamesGame from './ImportLeagueGamesGame.vue';

export default {
  props: ['league'],
  components: { ImportLeagueGamesGame },
  data: () => ({
    mappedLeagues: {
      'msu': 1,
      'nsu': 2,
      'myp': 3
    },
    mappedNewLeagues: {
      'msu': 8,
      'nsu': 9,
      'myp': 10
    },
    games: [],
    loading_games: false
  }),
  created() {
    this.getOldGames()
  },
  methods: {
    gameSaved({ old_game_id, new_game_id }) {
      // set imported_to_new to true - make sure reactivity works
      const mod = [ ...this.games ]
      const index = mod.findIndex(game => game.id === old_game_id)
      mod[index]['imported_to_new'] = true
      mod[index]['new_game_id'] = new_game_id
      this.games = mod
    },
    eventsSaved({ old_game_id }) {
      const mod = [ ...this.games ]
      const index = mod.findIndex(game => game.id === old_game_id)
      mod[index]['events_saved'] = true
      this.games = mod
    },
    gameDeleted({ old_game_id }) {
      const mod = [ ...this.games ]
      const index = mod.findIndex(game => game.id === old_game_id)
      mod[index]['imported_to_new'] = false
      mod[index]['new_game_id'] = null
      mod[index]['events_saved'] = false
      this.games = mod
    },
    getOldGames() {
      this.loading_games = true
      return new Promise((resolve, reject) => {
        a.get(`/import/games/${this.mappedLeagues[this.league]}/2024`)
          .then(res => {
            this.games = res.data
            resolve(res)
          })
          .catch(e => {
            this.$store.dispatch('noti/error', e)
            console.log(e)
            reject(e)
          })
          .finally(() => {
            this.loading_games = false
          })
      })
    }
  }
}
</script>